"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("./Button.style"));

var _getIconOrLoader = _interopRequireDefault(require("./utils/getIconOrLoader"));

var _Loader = _interopRequireDefault(require("../Loader"));

var renderIcon = function renderIcon(icon) {
  if (!icon) {
    return null;
  }

  if (_react.default.isValidElement(icon)) {
    return icon;
  }

  return _react.default.createElement(_Icon.default, icon);
};

var NormalButton = function NormalButton(props) {
  var text = props.text,
      children = props.children,
      icon = props.icon,
      iconPosition = props.iconPosition,
      style = props.style,
      textColorName = props.textColorName,
      hoverTextColorName = props.hoverTextColorName,
      iconFillName = props.iconFillName,
      hoverIconFillName = props.hoverIconFillName,
      disabled = props.disabled,
      onClick = props.onClick,
      status = props.status,
      theme = props.theme,
      className = props.className,
      clickedTextColorName = props.clickedTextColorName,
      clickedIconFillName = props.clickedIconFillName,
      size = props.size,
      loader = props.loader,
      other = (0, _objectWithoutProperties2.default)(props, ["text", "children", "icon", "iconPosition", "style", "textColorName", "hoverTextColorName", "iconFillName", "hoverIconFillName", "disabled", "onClick", "status", "theme", "className", "clickedTextColorName", "clickedIconFillName", "size", "loader"]);
  var buttonIcon = (0, _getIconOrLoader.default)(icon, loader);
  var textColor = theme.color[textColorName] || textColorName;
  var hoverTextColor = theme.color[hoverTextColorName] || hoverTextColorName;
  var iconFill = theme.color[iconFillName] || iconFillName;
  var hoverIconFill = theme.color[hoverIconFillName] || hoverIconFillName;
  var clickedTextColor = theme.color[clickedTextColorName] || clickedTextColorName;
  var clickedIconFill = theme.color[clickedIconFillName] || clickedIconFillName;
  return _react.default.createElement(_Button.default, (0, _extends2.default)({
    className: className,
    style: style,
    disabled: disabled,
    onClick: onClick,
    textColor: textColor,
    hoverTextColor: hoverTextColor,
    clickedTextColor: clickedTextColor,
    iconFill: iconFill,
    hoverIconFill: hoverIconFill,
    clickedIconFill: clickedIconFill,
    status: status,
    size: size
  }, other), iconPosition === 'left' && renderIcon(buttonIcon), text || children, iconPosition === 'right' && renderIcon(buttonIcon));
};

NormalButton.propTypes = {
  text: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.shape(_Icon.default.propTypes), _propTypes.default.element]),
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  style: _propTypes.default.object,
  textColorName: _propTypes.default.string,
  iconFillName: _propTypes.default.string,
  hoverTextColorName: _propTypes.default.string,
  hoverIconFillName: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  status: _propTypes.default.oneOf(['normal', 'danger', 'success']),
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'normal']),
  loader: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape(_Loader.default.propTypes)])
};
NormalButton.defaultProps = {
  text: '',
  icon: null,
  iconPosition: 'left',
  style: {},
  textColorName: 'black1',
  iconFillName: 'black1',
  hoverTextColorName: '',
  hoverIconFillName: '',
  onClick: function onClick() {},
  disabled: false,
  status: 'normal',
  className: '',
  size: 'normal',
  loader: false
};

var _default = (0, _emotionTheming.withTheme)(NormalButton);

exports.default = _default;